import React from 'react';

export const WixCompanyLogoSquare = () => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="41" height="41" rx="5.5" stroke="black" />
    <rect
      x="0.5"
      y="0.5"
      width="41"
      height="41"
      rx="5.5"
      fill="black"
      stroke="#F0F4F7"
    />
    <g clip-path="url(#clip0_2240_20710)">
      <path
        d="M35.7009 15.4004H34.0769C33.6264 15.4004 33.2053 15.6235 32.9523 15.9966L30.7805 19.2005C30.7226 19.2854 30.5972 19.2854 30.5393 19.2005L28.3675 15.9966C28.1149 15.6235 27.6934 15.4004 27.2429 15.4004H25.6189L29.4878 21.1076L25.6403 26.783H27.2643C27.7148 26.783 28.1358 26.5599 28.3889 26.1868L30.5393 23.0147C30.5972 22.9298 30.7226 22.9298 30.7805 23.0147L32.9309 26.1868C33.1835 26.5599 33.605 26.783 34.0555 26.783H35.6795L31.832 21.1076L35.7009 15.4004Z"
        fill="white"
      />
      <path
        d="M22.2776 16.5647V26.783H23.0537C23.697 26.783 24.2182 26.2618 24.2182 25.6187V15.4004H23.4421C22.7988 15.4004 22.2776 15.9216 22.2776 16.5647Z"
        fill="white"
      />
      <path
        d="M20.8534 15.4004H20.1627C19.4022 15.4004 18.7433 15.9263 18.5747 16.6677L17.0295 23.4604L15.6771 17.1196C15.4269 15.9477 14.2245 15.1574 12.994 15.4972C12.2102 15.7137 11.6292 16.3758 11.4597 17.1708L10.121 23.4519L8.57868 16.6682C8.40968 15.9268 7.75078 15.4004 6.99028 15.4004H6.30005L8.88867 26.7825H9.86943C10.7595 26.7825 11.5286 26.1603 11.7142 25.2898L13.369 17.524C13.3894 17.4276 13.4758 17.3579 13.5741 17.3579C13.6724 17.3579 13.7588 17.4276 13.7792 17.524L15.4355 25.2902C15.6211 26.1607 16.3901 26.7825 17.2802 26.7825H18.2643L20.8534 15.4004Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2240_20710">
        <rect
          width="29.4"
          height="11.3826"
          fill="white"
          transform="translate(6.30005 15.4004)"
        />
      </clipPath>
    </defs>
  </svg>
);
